$(document).ready(function(){
	const displayPopup = sessionStorage.getItem('displayPopup');

	// -- show popup --
	if (displayPopup != 'false') {
		$('.popup').removeClass('opacity-0 pointer-events-none');
	}

	// -- close popup with button --
	$('.popup__closeBtn').on('click', function(){
    closePopup();
	});

	// -- close popup with click outside --
	$(document).mouseup(function(e){
    const popupInner = $('.popup__inner');
    const cookiesBanner = $('.tarteaucitronCTAButton');
    if (!popupInner.is(e.target) && popupInner.has(e.target).length === 0 && !cookiesBanner.is(e.target)) {
      closePopup();
    }
	});

	function closePopup(){
		$('.popup').addClass('opacity-0 pointer-events-none');
		sessionStorage.setItem('displayPopup', 'false');
	}

});